import * as React from 'react';
import { SVGProps } from 'react';

const IconDataNullSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.724 2.553A1 1 0 0 1 2.618 2h6.764a1 1 0 0 1 .894.553l1.618 3.236a1 1 0 0 1 .106.447V10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6.236a1 1 0 0 1 .106-.447l1.618-3.236ZM3 3h6l1.5 3H9a1 1 0 0 0-1 1 1 1 0 0 1-1 1H5a1 1 0 0 1-1-1 1 1 0 0 0-1-1H1.5L3 3Z"
    />
  </svg>
);
export default IconDataNullSizeXs;
